// import { BrowserRouter } from 'react-router-dom';
import { start } from '@jutro/app';
import { loadGtag, initDefaultMixpanel } from '@jutro/events';
import { consumerThemeConfig } from '@jutro/theme-styles';
import { LocaleService } from 'gw-portals-i18n-react';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import 'regenerator-runtime';

import App from './app/App';

const { trackingConfig = {} } = appConfig;

const gaTrackingId = trackingConfig.GA4_TRACKING_ID;
const mixpanelTrackingId = trackingConfig.MIXPANEL_TRACKING_ID;

if (window.self === window.top) {
    const theBody = document.getElementsByTagName('body')[0];
    theBody.style.display = 'block';
} else {
    window.top.location = window.self.location;
}

// Initialize Google Analytics directly with tracking ID from config
if (gaTrackingId) {
    // Defer GA initialization to avoid conflict with webpack dev server's source map middleware
    if (document.readyState === 'complete') {
        loadGtag(gaTrackingId);
    } else {
        window.addEventListener('load', () => loadGtag(gaTrackingId));
    }
}
if (mixpanelTrackingId) {
    initDefaultMixpanel(trackingConfig);
}

start(App, {
    rootId: 'root',
    messageLoader: LocaleService.loadMessages,
    coreMessageLoader: LocaleService.loadCoreMessages,
    refreshOnLanguageOrLocaleChange: true,
    routerBasename: '/account-management',
    onInit: () => {
        LocaleService.register();
    },
    appName: {
        id: 'digital.appName',
        defaultMessage: 'Policyholder Portal',
    },
    appDescription: 'Policyholder Portal',
    themeConfig: consumerThemeConfig,
    modalProvider: 'default', // ToDo
});
